import React from 'react'
import { IconProps } from '../types'

export default function CalendarOutlineIcon({
    className = 'h-[17px] w-[15px]',
    stroke = '#000000',
    strokeOpacity = 0.4,
    ...props
}: IconProps & { stroke?: string; strokeOpacity?: number }) {
    return (
        <svg
            width="15"
            height="17"
            viewBox="0 0 15 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M3.08203 2.25065V0.583984M11.4154 2.25065V0.583984M3.08203 8.08398H11.4154M3.08203 11.4173H8.91536M13.082 2.25065C13.5404 2.25065 13.9154 2.62565 13.9154 3.08398V14.7507C13.9154 15.209 13.5404 15.584 13.082 15.584H1.41536C0.957031 15.584 0.582031 15.209 0.582031 14.7507V3.08398C0.582031 2.62565 0.957031 2.25065 1.41536 2.25065H13.082Z"
                stroke={stroke}
                strokeOpacity={strokeOpacity}
                strokeWidth="1.16667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
